import TableRow from '@mui/material/TableRow';
import IconTooltipButtom from '../../../../button/IconTooltipButton';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@mui/material';
import { Alert } from '@mui/material';
import './TemplateDropZonePreviewList.css';

const TemplateDropZonePreviewList = ({
  files,
  isLoading,
  uploaded = [],
  onDeleteFile,
  error,
  isFileValid = true
}) => {
  return (
    <aside
      className='flex flex-col _absolute bottom-0 inset-x-0 overflow-auto  pb-10 pt-2'
      style={{ overflow: 'hidden', overflowY: 'auto' }}
    >
      <div className='w-full'>{error && <Alert severity='error'>{error}</Alert>}</div>

      {files?.map((file, index) => {
        const { isUploading } = file;
        const fileUploaded = uploaded.find((item) => item.name === file.name);
        return (
          <TableRow
            component={'div'}
            key={index}
            className='px-4 py-2 flex gap-4 items-center justify-between'
            style={{
              backgroundColor: 'rgb(222, 237, 248)',
              color: isFileValid ? '#008764' : 'var(--destructive)'
            }}
          >
            <div className='flex items-center gap-1 text-center'>
              <span className='max-w-50px min-w-50px'>{index + 1}</span>
              <FontAwesomeIcon icon='fa-light fa-file' className='preview-list__file-icon' />
            </div>
            <div className='max-w-250px min-w-250px'>{file.name}</div>
            <div className='max-w-150px min-w-150px'>{file.size / 1000} KB</div>
            <div className='max-w-50px min-w-50px text-right'>
              {isLoading ? (
                <>
                  {fileUploaded ? (
                    fileUploaded.error ? (
                      <Tooltip title={fileUploaded.error} placement='top' arrow>
                        <FontAwesomeIcon
                          icon='exclamation-triangle'
                          className='text-secondary cursor-pointer'
                        />
                      </Tooltip>
                    ) : (
                      <FontAwesomeIcon icon='check' color='green' />
                    )
                  ) : (
                    <FontAwesomeIcon icon='spinner' spin />
                  )}
                </>
              ) : (
                <div style={{ display: 'flex', gap: '5px' }}>
                  {isUploading && (
                    <Box sx={{ display: 'flex' }}>
                      <CircularProgress size={20} />
                    </Box>
                  )}
                  <IconTooltipButtom
                    id={`delete-${file.name}`}
                    title={file?.alreadyAdded ? 'Delete' : 'Remove'}
                    icon={file?.alreadyAdded ? 'trash-alt' : 'close'}
                    onClick={() => onDeleteFile(file)}
                  />
                </div>
              )}
            </div>
          </TableRow>
        );
      })}
    </aside>
  );
};

export default TemplateDropZonePreviewList;
